import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pbx } from 'src/app/domains/equipment/models';
import { Queue, RING_STRATEGY } from 'src/app/domains/queues/models';
import { QueuesService } from 'src/app/domains/queues/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-queue-ring-strategy-popup',
  templateUrl: './queue-ring-strategy-popup.component.html',
  styleUrls: ['./queue-ring-strategy-popup.component.scss']
})
export class QueueRingStrategyPopupComponent implements OnInit {
  public queue: Queue;
  public pbx: Pbx;
  public currentRingStrategy: RING_STRATEGY;
  public ringStrategy = Object.values(RING_STRATEGY);
  public loading: boolean = false;
  @Output() emitRingStrategy: EventEmitter<Queue> = new EventEmitter();

  constructor(
    private modal: NgbActiveModal,
    private queuesService: QueuesService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.currentRingStrategy = this.queue.user_strategy;
  }

  public saveModule(): void {
    this.loading = true;
    const payload: Queue = {
      ...this.queue,
      user_strategy: this.currentRingStrategy
    };
    this.queuesService.updateQueue(this.pbx.id, payload).subscribe((res: Queue) => {
      this.emitRingStrategy.emit(res);
      this.loading = false;
      this.close();
    }, () => {
      this.notification.error('company.queues.ring-strategy-popup.error');
      this.loading = false;
      this.close();
    });
  }

  public close() {
    this.modal.close()
  }
}
